// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"91":"2b096205efe3fd24","8768":"0bf0200dad6bc6c7"}[chunkId] + ".css";
};